module.exports = __webpack_public_path__ + "static/media/success.5cf5fe35.svg";